<template>
  <div class="apply">
    <img :src="data.url"  alt="">
    <div class="apple__right">
      <p >{{data.title}}</p>
      <p>{{data.des}}</p>
    </div>
    <div class="line"></div>
    <div class="apple__bt cursor" @click="changeShow">
      <p>申请接入</p>
    </div>
  </div>
</template>
<script>
/**
 * 分类块
 *
 * @requires Type.vue
 * @author dongyang
 */
export default {
  name: 'ApplyType',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    changeShow () {
      this.$emit('listen-is-show', true)
    }
  }
}
</script>
<style lang="scss" scoped>
.apply {
  box-sizing: border-box;
  position: relative;
  width: 220px;
  height: 180px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 20px 0px rgba(226, 226, 232, 1);
   border: 2px solid rgba(255, 255, 255, 1);
  text-decoration: none;
  &:hover {
    box-shadow: 0px 6px 20px 0px rgba(226, 226, 232, 1);
    border: 2px solid #2890ec;
  }
  img {
    position: absolute;
    top: 30px;
    left: 23px;
  }
  .apple__right {
    margin-left: 75px;
    padding-top: 24px;
    p:first-of-type {
      font-size: 18px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(33, 33, 42, 1);
      line-height: 30px;
    }
    p:last-of-type {
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(33, 33, 42, 1);
      line-height: 22px;
    }
  }
  .line {
    margin: 15px auto 0;
    width: 190px;
    height: 1px;
    background: rgba(243, 243, 248, 1);
  }
  .apple__bt {
    margin: 20px auto 0px;
    width: 160px;
    height: 40px;
    background: rgba(40, 144, 236, 1);
    &:hover {
      background:rgba(92,175,249,1);
    }
    p {
      text-align: center;
      margin: 0 auto;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
    }
  }
}
</style>
